import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logo from 'images/logo'
import ProjectList from './ProjectList'
import LocationSearch from './LocationSearch'
import MobileError from './MobileError'
import Notification from 'components/Notification'
import LoginForm from 'components/LoginForm'
import { hideMobileStartAction } from 'actions/applicationActions'
import { createMobileProjectAction, selectProjectAction, migrateLegacyProject } from 'actions/projectActions'
import { CREATE_MOBILE_PROJECT } from 'actions/projectActionTypes'
import { notificationAction } from 'actions/notificationActions'
import pathEq from 'ramda/src/pathEq'

const mapStateToProps = ({ showMobileStart, mobileError, database, notification, offline, projects, cameraModels, ui }) => {
  return {
    showMobileStart,
    mobileError,
    database,
    notification,
    loading: (offline == null) || (!offline && (!projects || !cameraModels)),
    offline,
    projects,
    cameraModels,
    offlineTimeLimit: ui && ui.offlineTimeLimit
  }
}

const initialState = { newProject: false, openProject: false, useLocation: false, enterAddress: false }

const mostRecentProject = projects => {
  let max = projects[0].updatedAt
  let project = projects[0]

  projects.forEach(p => {
    if (p.updatedAt > max) {
      max = p.updatedAt
      project = p
    }
  })

  return project
}

class MobileStart extends React.Component {
  state = initialState

  componentWillReceiveProps(nextProps) {
    if (this.props.notification !== nextProps.notification && pathEq(['notification', 'type'], CREATE_MOBILE_PROJECT)(nextProps)) {
      this.showNewProject()
    }
  }

  handleClick(e) {
    const { props: { mobileError }, state: { newProject, openProject, useLocation, enterAddress }} = this

    if (mobileError) return window.location.href = IPVM_URL

    if (useLocation || enterAddress) {
      this.setState({ ...initialState, newProject: true })
    } else if (openProject || newProject) {
      this.setState(initialState)
    } else if (!newProject && !openProject) {
      window.location.href = IPVM_URL
    } else {
      this.setState(initialState)
    }
  }

  backButtonText = _ => {
    const { state: { newProject, openProject, useLocation }, props: { mobileError } } = this

    if (mobileError) return 'Website'
    if (!newProject && !openProject) return 'Website'
    if (useLocation) return 'Cancel'
    return 'Back'
  }

  resumeProject = _ => {
    const { props: { showMobileStart, hideMobileStartAction, offline, projects, cameraModels, migrateLegacyProject, selectProjectAction } } = this

    if (showMobileStart) return hideMobileStartAction()

    if (offline || !projects || !cameraModels) return

    const filteredProjects = projects.filter(p => p.updatedAt !== undefined)

    if (filteredProjects.length === 0) return

    // launch most recently updated project
    const mostRecent = mostRecentProject(filteredProjects)
    mostRecent.legacyId ? migrateLegacyProject(mostRecent) : selectProjectAction(mostRecent.id)
  }

  showResumeButton = _ => {
    const { showMobileStart, offline, projects, cameraModels, classes } = this.props

    if (showMobileStart) return true
    if (offline || (projects && projects.filter(p => p.updatedAt !== undefined).length === 0)) return false

    return (!projects || !cameraModels) ? false : true
  }

  startGeolocate() {
    if (!navigator.geolocation) return
    const { createMobileProjectAction, notificationAction } = this.props

    const geoSuccess = position => {
      if (!this.state.useLocation) return

      const location = { lat: position.coords.latitude, lng: position.coords.longitude }
      createMobileProjectAction(location, 19)
    }

    const geoError = error => {
      if (error.code === 3) notificationAction('Geolocation error: timeout reached')
      else if (error.code === 1) notificationAction('Geolocation error: permission denied')
      else notificationAction('Could not get location')

      this.showNewProject()
    }

    const geoOptions = {
      timeout: 5 * 1000
    }

    navigator.geolocation.getCurrentPosition(geoSuccess, geoError, geoOptions)
    this.setState({ useLocation: true })
  }

  showNewProject() {
    this.setState({ ...initialState, newProject: true })
  }

  loginForm = _ => {
    return (
      <div className={this.props.classes.loginContainer}>
        <div className={this.props.classes.loginHeader}>
          { this.props.offlineTimeLimit ? 'Time Limit Reached' : 'Subscriber Only Feature' }
        </div>
        <div style={{ padding: '2rem' }}>
          <LoginForm resetState={(_ => this.setState(initialState)).bind(this)} />
        </div>
      </div>
    )
  }

  renderBody() {
    const { showNewProject, startGeolocate, loginForm, resumeProject, state: { newProject, openProject, useLocation, enterAddress },
            props: { mobileError, database, loading, offline, showMobileStart, classes } } = this

    if (mobileError) return <MobileError />

    if (enterAddress) return <LocationSearch />
    else if (useLocation) {
      return (
        <div className={classes.loading}>
          <FontAwesomeIcon icon='spinner' className={`${classes.loadingButton} fa-spin`} />
          Locating You...
        </div>
      )
    } else if (newProject) {
      if (offline && showMobileStart) return loginForm()

      if (!offline && !database) {
        return (
          <div className={classes.loading}>
            <FontAwesomeIcon icon='spinner' className={`${classes.loadingButton} fa-spin`} />
            Loading...
          </div>
        )
      }

      return (
       <div className={classes.dialog}>
          <div className={classes.header}>
            Where is your project?
          </div>
          <div onClick={startGeolocate.bind(this)} className={`${classes.greenButton} ${!navigator.geolocation && classes.disabled}`}>
            <FontAwesomeIcon icon='location-arrow' className={classes.locationButton} />
            Use My Location
          </div>
          <span style={{ fontSize: '1.5rem' }}>{ navigator.geolocation ? "We only use it in the calculator" : "Your browser does not support location" }</span>
          <div onClick={_ => this.setState({ enterAddress: true })} className={classes.blueButton}>
            <FontAwesomeIcon icon={['far', 'map']} className={classes.mapButton} />
            Enter Address
          </div>
       </div>
      )
    } else if (openProject) {
      if (offline) return loginForm()

      return <ProjectList showNewProject={showNewProject.bind(this)} />
    }

    return (
      <div className={classes.dialog}>
        <div className={classes.header}>
          IPVM Designer / Calculator
        </div>
        {
          loading
          ? <div className={classes.loadingContainer}>
              <FontAwesomeIcon icon='calculator' className={`${classes.loadingIcon} fa-spin`} />
              <span>The world's most widely used video surveillance design tool</span>
            </div>
          : <div>
              <div onClick={_ => this.setState({ newProject: true })} className={classes.greenButton}>
                New Project
              </div>
              <div onClick={_ => this.setState({ openProject: true })} className={classes.blueButton}>
                Open Project
              </div>
              { this.showResumeButton() &&
                <div onClick={resumeProject} className={classes.blueButton}>
                  Resume Project
                </div>
              }
            </div>
        }
      </div>
    )
  }

  render() {
    const { handleClick, backButtonText, props: { classes } } = this

    return (
      <div className={classes.appContainer}>
        <div className={classes.topBar}>
          <div className={classes.backLink} onClick={handleClick.bind(this)}>
            <FontAwesomeIcon icon='chevron-left' className={classes.backButton} />
            { backButtonText() }
          </div>
          <img src={logo} alt='IPVM Logo' className={classes.logo} />
          <div style={{ flex: 1 }} />
        </div>
        <div className={classes.startBody}>
          {this.renderBody()}
        </div>
        <Notification />
      </div>
    )
  }
}

export default connect(mapStateToProps, { hideMobileStartAction, createMobileProjectAction, migrateLegacyProject, selectProjectAction, notificationAction })(injectSheet(style)(MobileStart))



// WEBPACK FOOTER //
// ./src/components/MobileStart/index.js